/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal, { ModalHeader, ModalFooter } from '../../../../components/Modal';
import Button from '../../../../components/Button';

import styles from '../../../../styles';

const ModalBody = styled.div`
  padding: 2rem;
  ${styles.fonts.base};
  color: ${styles.colors.biscay};
`;

class RemovePhoneNumberModal extends React.Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  static propTypes = {
    requests: PropTypes.object,
    onClose: PropTypes.func
  };

  submit(){
    this.props.requests.removePhone
      .handleRequest({
        body: {
          phoneNumber: '',
          countryName: '',
          mobileNumberVerified: false,
          smsSubscribed: false,
        }
      })
      .then(() => {
        this.props.requests.subscriber.handleRequest();
        this.props.onClose(
          'success',
          'You have successfully removed your phone number'
        );
      })
      .catch(() => {
        this.props.requests.subscriber.handleRequest();
        this.props.onClose('failure', 'There was an error. Please try again');
      });
  }

  render() {
    return (
      <Modal onClose={this.props.onClose}>
        <ModalHeader text="Remove Phone" />
        <ModalBody>
          {'Are you sure you want to remove your mobile phone number ?'}
        </ModalBody>
        <ModalFooter>
          <Button onClick={this.props.onClose}>Cancel</Button>
          <Button theme="destructive" onClick={this.submit}>
            Remove
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default RemovePhoneNumberModal;
